import { render, staticRenderFns } from "./soltPh.vue?vue&type=template&id=58241273&scoped=true"
import script from "./soltPh.vue?vue&type=script&lang=js"
export * from "./soltPh.vue?vue&type=script&lang=js"
import style0 from "./soltPh.vue?vue&type=style&index=0&id=58241273&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58241273",
  null
  
)

export default component.exports